import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { OrderProductDialogState } from '../../services/order-product-dialog.state';
import { OrderGroupDetailPayload } from '../../models/order-detail.model';
import { CommonModule } from '@angular/common';
import { UtilService } from '@core/utils/util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { HorusLoadingComponent } from '@shared/components/domain/horus-loading/horus-loading.component';
import { OrderActionBase } from '@features/order-actions/models/order-action.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HorusMessageGeneralComponent } from '@shared/components/domain/horus-message-general/horus-message-general.component';
import { OrderDispatch } from '@features/orders/services/order-product.service';

@Component({
  selector: 'app-order-product-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatTooltipModule,
    HorusLoadingComponent,
    HorusMessageGeneralComponent
  ],
  templateUrl: './order-product-dialog.component.html',
  styleUrl: './order-product-dialog.component.scss',
  providers: [OrderProductDialogState]
})
export class OrderProductDialogComponent implements OnInit {

  readonly dialogRef = inject(MatDialogRef<OrderProductDialogComponent>);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly state = inject(OrderProductDialogState);
  readonly utilService = inject(UtilService);
  readonly router = inject(Router);

  constructor(@Inject(MAT_DIALOG_DATA) public data: OrderActionBase){}

  ngOnInit(): void {
    if (this.data.tenantId && this.data.orderGroup && this.data.orderType) {
      const payload: OrderGroupDetailPayload = {
        tenantId: this.data.tenantId,
        orderGroup: this.data.orderGroup,
        orderType: this.data.orderType,
      };
      this.state.search(payload);
    }
  }

  getShippingEstimate(dispatch : OrderDispatch): Date | undefined {
    return dispatch.currentState == 'DELIVERED' ? dispatch.shippingEstimate : dispatch.deliveryDate;
  }

  getDeliveryDate(dispatch : OrderDispatch): Date | undefined {
    return dispatch.currentState == 'DELIVERED' ? dispatch.deliveryDate : undefined;
  }

  redirectOrderGroupDetail(orderId?: string, dispatchNumber?: string) {
    let queryParams: any = {...this.activatedRoute.snapshot.queryParams};
    queryParams[environment.nameTypeRedirectParamUrl] = 'ORDER_GROUP';
    queryParams[environment.nameOrderIdParamUrl] = orderId;
    queryParams[environment.nameDispatchNumberParamUrl] = dispatchNumber;
    // Usar orderId en lugar de orderGroup en la ruta
    this.router.navigate(['orders', this.data.tenantId, orderId, this.data.orderType, 'detail'], { queryParams });
    this.dialogRef.close();
  }
}
